<template>
<div>
<div class="text-center loading-overlay" v-if="loading">
    <b-spinner></b-spinner>
</div>
  <div class="col-md-12" style="">
    <div class="text-right col-md-12 mb-4">
          <div class="d-flex justify-content-end">
              <div class="mx-2 tabs" :class="{'active': daysSelected == 7}" @click="changeDaysSelected(7)">7D</div>
              <div class="mx-2 tabs" :class="{'active': daysSelected == 10}" @click="changeDaysSelected(10)">10D</div>
              <div class="mx-2 tabs" :class="{'active': daysSelected == 15}" @click="changeDaysSelected(15)">15D</div>
              <div class="mx-2 tabs" :class="{'active': daysSelected == 20}" @click="changeDaysSelected(20)">20D</div>
              <div class="mx-2 tabs" :class="{'active': daysSelected == 30}" @click="changeDaysSelected(30)">30D</div>
          </div>
      </div>
    <canvas height="250" id="leader-board"></canvas>
  </div>
</div>
</template>

<script>
import Chart from 'chart.js'
const axios = require("axios");
import * as _ from 'lodash'
export default {
  name: 'dailyBooking',
  data() {
    return {
      loading: false,
      chartData: [],
      labelData: [],
      daysSelected: 7
    };
  },
  watch:{
      daysSelected(){
        this.loadData()
      }
  },
  mounted() {
  },
  created(){
    this.loadData()
  },
  methods:{ 
    changeDaysSelected(day) {
        this.daysSelected = day
    },
    async loadData() {
        this.loading= true
      try {
        var {data} = await axios
          .get(
            "https://glacier.on-track.in/api/agentActivity/leaderboard?days=" + this.daysSelected,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
        )
        var leaderBoardData = data[0]
        this.chartData = []
        this.labelData = []
        var ordered = _.orderBy(leaderBoardData, 'count', 'desc')
        var spliced = _.orderBy(ordered.splice(0, 10), 'count', 'asc')
        spliced.forEach((data, index) => {
            this.chartData.push(data.count)
            this.labelData.push((index === 9 ? '#1': '') + data.name)
        });
      } finally {
        const ctx = document.getElementById('leader-board');
        var cxRetentionStats = {
          type: 'bar',
          data: {
            labels: this.labelData.reverse(),
            datasets: [
              {
                data: this.chartData.reverse(),
                backgroundColor:'rgba(75, 192, 192, 0.2)',
                borderColor:'rgb(54, 162, 235)',
                borderWidth: 2
              },
            ]
          },
          options: {
            legend: {
              display: false
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(128,0,0,0.04)",
                      drawBorder: false
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(128,0,0,0.04)",
                      drawBorder: false
                  },
                }
              ]
            }
          },
        }
        new Chart(ctx, cxRetentionStats);
        this.loading = false
      }
    }
  },
  computed:{}
};
</script>

<style>
.tabs {
    cursor: pointer;
}
.active {
    font-weight: bold;
    color: #7b72ff;
}
.loading-overlay{
    position: absolute;
    width: 100%;
    margin: 10% 0;
    color: #7b72ff;
}
</style>